import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { FormEvent, ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { FormAlert } from '../../../components/FormAlert';
import { InputStatus } from '../../../models/error.model';
import { PasswordWithScoreInputsContainer } from '../containers/PasswordWithScoreInputsContainer';

interface IResetPasswordFormProps {
  passwordStatus: InputStatus;
  externalStatus: InputStatus;
  isDisabledSubmit: boolean;
  onPasswordChange: (value: string) => void;
  onPasswordStatusChange: (status: InputStatus) => void;
  onResetPassword: () => Promise<void>;
}

export const ResetPasswordForm = observer((props: IResetPasswordFormProps): ReactElement => {
  const { t } = useTranslator();

  const onSubmit = (event: FormEvent): void => {
    event.preventDefault();
    void props.onResetPassword();
  };

  const validationErrorOccurred = props.externalStatus.isValid === false || props.passwordStatus.isValid === false;

  return (
    <S_Card>
      <form
        onSubmit={onSubmit}
        className='auth-form'
      >
        <ColumnLayout size='md'>
          <FormAlert
            errors={props.externalStatus}
            useDefaultMessageWhenCodeNotFound={true}
          />
          <PasswordWithScoreInputsContainer
            labelText={t('password')}
            onPasswordChange={props.onPasswordChange}
            onPasswordStatusChange={props.onPasswordStatusChange}
          />
          <Button
            type='submit'
            onClick={onSubmit}
            disabled={validationErrorOccurred || props.isDisabledSubmit}
          >
            {t('reset_password')}
          </Button>
        </ColumnLayout>
      </form>
    </S_Card>
  );
});
